<template>
    <div>
        <Transition name="fade">
            <div @click="closeAction" v-if="isOpen" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <CommonPopupFrame :isShowBackground="false" :zIndex="30" background="#fff" :changeBottom="0" :changeHeight="100" :isOpen="isOpen" :closeCompleteAction="closeAction">
            <div @click="closeAction" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <div @touchmove.stop="() => { }" style="padding: 0 12px; flex: 1;" v-if="formType === FORM_TYPE.TOPIC && !isJoin">
                <div style="margin-top: 40px;">
                    <swiper @slideChange="slideChange" style="border-radius: 12px; overflow: hidden;" ref="swiper" :options="swiperOption" role="tablist">
                        <swiper-slide v-for="each, index in topics" :key="index + 'topic2'" style="width: 100%; height: 100%; max-height: 220px; min-height: 215px; position: relative; border-radius: 12px; padding: 12px; display: flex; flex-direction: column;" role="tab">
                            <div style="background: #210F0399; position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -1;"></div>
                            <img style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -2; object-fit: fill;" :src="require('@/assets/img/test_back.png')" alt="">
                            <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #BBBBBB;">
                                이번주 토픽
                                <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #BBBBBB;"></span>
                                <span style="color: #fff;">{{ each.join_cnt | comma }}명</span> 참여
                            </div>
                            <div style="flex: 1; display: flex; flex-direction: column;">
                                <div style="text-align: center; margin-bottom: 8px; margin-top: -16px;">
                                    <div style="width:40px;height:40px;"></div>
                                    <!--<ProfileImage :imagePath="each.image_path" style="width: 40px;"></ProfileImage>-->
                                </div>
                                <div style="font-size: 20px; color: #fff; font-weight: 700; line-height: 32px; flex: 1;">{{ $Util.removeYoutubeLink(each.contents) }}</div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; padding-right: 20px; display:inline-block;"></div>
                    </swiper>
                </div>
                <div style="margin-top: 20px;">
                    <textarea placeholder="자유롭게 질문하세요" v-model="topicContents" style="background: #210F030D; border-radius: 12px; height: 240px; padding: 12px; line-height: 24px; font-size: 18px; width: 100%; resize: none; border: none; outline: none;"></textarea>
                </div>
            </div>
            <div @touchmove.stop="() => { }" style="flex: 1; padding: 0 12px; overflow-y: scroll;" v-else-if="formType === FORM_TYPE.SKILL || isJoin || formType === FORM_TYPE.POSITION || formType === FORM_TYPE.TRAINING">
                <div style="">
                    <div v-if="formType === FORM_TYPE.SKILL" style="margin-top: 44px; text-align: center; font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">배우고 싶은 기술은 물어보고,<br>자신만의 실력을 마음껏 보여주세요!</div>
                    <div v-else-if="formType === FORM_TYPE.POSITION" style="margin-top: 44px; text-align: center; font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">포지션 찾기 전,<br>배우고 싶은 축구 기술이나 궁금한<br>내용 자유롭게 작성해보세요</div>
                    <div v-else-if="formType === FORM_TYPE.TRAINING" style="margin-top: 44px; text-align: center; font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">이번 주 훈련 영상,<br>직접 업로드해보세요</div>
                    <div v-else style="margin-top: 44px; text-align: center; font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">감독님들에게 보여드릴<br> 입단 요청서를 만들어볼게요</div>
                    <textarea v-model="sc_contents" :placeholder="setPlaceHolder" style="min-height: 120px; outline: none; resize: none; line-height: 32px; border: none; width: 100%; border-radius: 12px; background-color: #210F030D; padding: 12px;" name="" id=""></textarea>
                    <template v-if="formType === FORM_TYPE.TRAINING && trainingBannerList.length > 0">
                        <div style="display: flex; font-size: 14px; justify-content: space-between; align-items: center; margin-top: 36px;">
                            <div style="font-weight: 700; line-height: 20px;">어떤 훈련을 진행했나요?<span style="color: var(--color-main);"> *</span></div>
                            <div style="font-weight: 500; color: #797979;">1개 선택</div>
                        </div>
                        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px 16px; margin-top: 12px;">
                            <div @click="selectTrainingBanner(each)" :class="{ 'active': each.idx == selectedReferIdx }" v-for="each, index in trainingBannerList" :key="index + 'training_banner'" class="training_banner_item">
                                <div class="ellipsis" style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.contents.split('|||')[0] }}</div>
                            </div>
                            <div @click="selectTrainingBanner({ idx: -2 })" :class="{ 'active': selectedReferIdx == -2 }" class="training_banner_item">
                                <div class="ellipsis" style="font-weight: 500; font-size: 14px; line-height: 24px;">나만의 개인 훈련 영상 올리기</div>
                            </div>
                        </div>
                    </template>
                    <div style="margin-top: 32px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 20px;">미디어를 첨부하여 많은 사람에게 피드를 보여주세요</div>
                        <!-- <div style="font-weight: 700; font-size: 12px; line-height: 20px; color: #808080;">최소 한 장의 미디어를 추가해주세요</div> -->
                        <div style="display: flex; margin: 0 -12px; padding: 0 12px; gap: 12px; margin-top: 8px; overflow-x: scroll;" class="hide_scroll">
                            <div v-for="each, i in 3" :key="i">
                                <div v-if="!imgSrcArr[i]" @click="showFiles(i)" style="width: 200px; height: 200px; background-color: #210F034D; gap: 8px; flex-direction: column; border-radius: 12px; flex-shrink: 0; display: flex; justify-content: center; align-items: center;">
                                    <img style="width: 32px;" :src="require('@/assets/img/request_form_img.png')" alt="">
                                    <div style="font-size: 12px; line-height: 24px; font-weight: 700; color: #fff;">이미지 추가</div>
                                </div>
                                <div style="position: relative;" v-else-if="imgSrcArr[i] && !imgSrcArr[i].isVideo">
                                    <img style="width: 200px; height: 200px; border-radius: 12px; object-fit: cover;" :src="imgSrcArr[i].src" alt="">
                                    <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                        <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                    </div>
                                </div>
                                <div style=" position: relative;" v-else-if="imgSrcArr[i] && imgSrcArr[i].isVideo">
                                    <video :ref="'videoElement' + i" width="200" height="200" style="border-radius: 12px;" autoplay="false">
                                        <source :src="imgSrcArr[i].src + $Util.getStrForVideoPreview()" type="video/mp4">
                                    </video>
                                    <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                        <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 32px; margin-bottom: 30px;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 20px;">유튜브에 영상이 있다면 링크를 첨부해주세요</div>
                        <div style="position:relative; margin-top: 8px;">
                            <img :src="require('@/assets/img/soccerhow_write_link_url.png')" style="position:absolute; left:12px; top: 50%; transform: translateY(-50%); width:20px; height:18px;">
                            <input style="border:0px; height: 56px; border-radius: 12px; outline:none; width:100%; background-color: #210F030D; font-size:16px;color:black; padding: 10px 0px; padding-left:37px;" placeholder="유튜브 URL" @blur="detectLink" @click.stop ref="linkRef" v-model="youtubeLink" />
                        </div>
                        <div v-if="isShowYoutubeFrame" style="border-radius:12px;overflow:hidden; margin-top: 8px;">
                            <ContentsViewer :contents="youtubeLink" style="" />
                        </div>
                    </div>
                    <div style="display:flex; align-items: center;">
                        <!-- 사진 여러장 업로드 할 시 input태그 추가 -->
                        <input type="file" style="display:none;" ref="file0" data-id="file0" @change="readURL($event)">
                        <input type="file" style="display:none;" ref="file1" data-id="file1" @change="readURL($event)">
                        <input type="file" style="display:none;" ref="file2" data-id="file2" @change="readURL($event)">
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 20px;">
                <div @click="makeFeedAsk" v-if="formType === FORM_TYPE.TOPIC && !isJoin" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">작성하기</div>
                <div @click="makeFeed" v-else-if="formType === FORM_TYPE.SKILL && !isJoin" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">만들기</div>
                <div @click="makeFeed" v-else-if="formType === FORM_TYPE.POSITION && !isJoin" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">만들기</div>
                <div @click="makeFeed" v-else-if="formType === FORM_TYPE.TRAINING && !isJoin" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">만들기</div>
                <div @click="makeFeedJoin" v-else-if="isJoin" style="width: 286px; font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #210f03; margin: 0 auto; margin-top: 20px;">완료</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
const FORM_TYPE = {
    TOPIC: 'TOPIC',
    SKILL: 'SKILL',
    POSITION: 'POSITION',
    TRAINING: 'TRAINING'
}

import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ContentsViewer from "@/components/common/ContentsViewer";
import { SOCCER_HOW_TYPE } from '@/Constants'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: 'LearnSoccerWriteFormModal',
    components: { CommonPopupFrame, ContentsViewer, swiper, swiperSlide },
    props: {
        formType: {
            type: String,
            default: FORM_TYPE.TOPIC
        },
        refresh: {
            type: Function,
            default: () => { }
        },
        topics: {
            type: Array,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        isJoin: {
            type: Boolean,
            default: false
        },
        setSelectPurpose: {
            type: Function,
            default: () => { }
        },
        isFromPageBottom: {
            type: Boolean,
            default: false
        },
        refer_idx: {
            type: Number,
            default: 0
        },
        trainingBannerList: {
            type: Array,
            default: () => {}
        },
        beforeCompleteAction: {
            type: Function,
            default: () => { }
        }
    },
    watch: {
        isShowWriteForm(newVal) {
            this.topicContents = '';
            //처음만
            if (this.topics && this.topics.length > 0 && !this.selectedPost.idx) this.selectedPost = this.topics[0];
            if (!newVal && !this.isJoin) {
                this.resetWriteForm()
            }
        },
    },
    computed: {
        setPlaceHolder() {
            if (this.formType === FORM_TYPE.TRAINING) {
                return '훈련 영상을 보고 따라 한 뒤 촬영해보세요\n업로드하면 전문가 피드백으로 실력, 한 단계 업!'
            } else {
                return '자유롭게 작성하세요'
            }
        }
    },
    data() {
        return { 
            selectedReferIdx: null,
            isOpen: false,
            FORM_TYPE: FORM_TYPE,
            topicContents: '',
            isShowYoutubeFrame: false,
            youtubeLink: '',
            imgSrcArr: [null, null, null],
            curIndex: -1,
            sc_contents: '',
            swiperOption: {
                observer: true,
                observeParents: true,
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            selectedPost: {},
            device: ''
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    methods: {
        selectTrainingBanner(each) {
            this.selectedReferIdx = each.idx
        },
        closeAction() {
            this.isOpen = false;
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        resetWriteForm() {
            for (let i = 0; i < 3; i++) {
                this.$refs['file' + i].value = ''
            }
            this.sc_contents = ''
            this.imgSrcArr = [null, null, null]
            this.youtubeLink = ''
            this.topicContents = ''
        },
        slideChange() {
            const swiper = this.$refs.swiper.swiper; // Swiper 인스턴스 가져오기
            const currentIndex = swiper.activeIndex;   // 현재 슬라이드의 인덱스
            this.selectedPost = this.topics[currentIndex]
        },
        async makeFeedAsk() {
            if (this.topicContents === '') {
                this.$GlobalStore.showAlert('내용을 입력해주세요.');
                return;
            }

            const formData = new FormData();
            formData.append('topic', '')
            formData.append('entredPoint', 0)
            formData.append('isCheckedFastAnswer', '0')
            formData.append('title', '');
            formData.append('contents', this.topicContents);
            formData.append('type', SOCCER_HOW_TYPE.SINGLE_TRAINING)
            formData.append('topic_idx', this.selectedPost.idx)
            formData.append('mode', 'insert');

            const res = await this.$Axios.post('/api/soccerhow/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) {
                this.completeAction();
                this.$Util.sendEventClick('축구배우기_게시글_작성', true)
                this.$GlobalStore.showToast('질문이 등록되었습니다.');
                this.closeAction()
            }
        },
        makeFeedJoin() {
            if (this.sc_contents === '') {
                this.$GlobalStore.showAlert('내용을 입력해주세요.');
                return;
            }

            if (/(.)\1{3,}/.test(this.sc_contents)) {
                this.$GlobalStore.showAlert('같은 글자를 4개 이상 반복할 수 없습니다.');
                return
            }

            if (this.sc_contents.length < 5) {
                this.$GlobalStore.showAlert('5자 이상 입력해주세요.')
                return
            }

            if (this.youtubeLink !== '') {
                if (!this.$Util.checkYoutubeLink(this.youtubeLink)) {
                    this.$GlobalStore.showAlert('잘못된 유튜브 링크 입니다.');
                    return;
                }
            }

            const allFalse = this.imgSrcArr.every(value => value === null);

            if (allFalse && this.formType === FORM_TYPE.TOPIC) {
                this.$GlobalStore.showAlert('최소 한 장의 미디어를 추가해주세요')
                return
            }


            for (let i = 0; i < this.imgSrcArr.length; i++) {
                if (this.imgSrcArr[i]) {
                    const curImgSrc = this.imgSrcArr[i];
                    if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                        this.imgSrcArr[i].value = this.$refs[curImgSrc.id].files[0]
                    }
                }
            }
            const shortRequest = {
                type: this.formType === FORM_TYPE.TOPIC ? 'p' : 'l',
                p_say: this.sc_contents + this.youtubeLink,
                l_say: this.sc_contents + this.youtubeLink,
                imgSrcArr: this.imgSrcArr,
                isYoutubeExist: this.youtubeLink !== '' ? '1' : '0'
            }
            this.closeAction()
            this.setSelectPurpose('', -1, true, shortRequest)
        },
        async makeFeed() {
            if (this.sc_contents === '') {
                this.$GlobalStore.showAlert('내용을 입력해주세요.');
                return;
            }

            if (/(.)\1{3,}/.test(this.sc_contents)) {
                this.$GlobalStore.showAlert('같은 글자를 4개 이상 반복할 수 없습니다.');
                return
            }

            if (this.sc_contents.length < 5) {
                this.$GlobalStore.showAlert('5자 이상 입력해주세요.')
                return
            }

            // const allFalse = this.imgSrcArr.every(value => value === null);

            // if (allFalse) {
            //     this.$GlobalStore.showAlert('최소 한 장의 미디어를 추가해주세요')
            //     return
            // }

            if (this.youtubeLink !== '') {
                if (!this.$Util.checkYoutubeLink(this.youtubeLink)) {
                    this.$GlobalStore.showAlert('잘못된 유튜브 링크 입니다.');
                    return;
                }
            }

            if (this.formType === FORM_TYPE.TRAINING && this.trainingBannerList.length > 0 && !this.selectedReferIdx) {
                this.$GlobalStore.showAlert('어떤 훈련을 진행했는지 선택해주세요.');
                return;
            }

            if (this.formType === FORM_TYPE.TRAINING) {
                const allFalse = this.imgSrcArr.every(value => value === null);
                if (allFalse && this.youtubeLink === '') {
                    this.$GlobalStore.showAlert('최소 한 장의 미디어 또는 유튜브 링크를 추가해주세요')
                    return
                }
            }

            if (this.formType === FORM_TYPE.TRAINING) {
                let isAllVideo = true
                this.imgSrcArr.forEach(item => {
                    if (item) {
                        if (!item.isVideo) {
                            isAllVideo = false
                        }
                    }
                })
                if (!isAllVideo) {
                    alert('훈련 영상은 동영상만 업로드 가능합니다.')
                    return
                }
            }

            const formData = new FormData();
            // const formType = SOCCER_HOW_TYPE.SC_COUNSEL + ',' + SOCCER_HOW_TYPE.SC_JOIN + ',' + SOCCER_HOW_TYPE.SC_JOB
            formData.append('topic', '')
            formData.append('entredPoint', 0)
            formData.append('isCheckedFastAnswer', '0')
            formData.append('title', '');
            formData.append('contents', this.sc_contents + this.youtubeLink);
            formData.append('type', SOCCER_HOW_TYPE.SINGLE_TRAINING)
            formData.append('mode', 'insert');
            formData.append('isYoutubeExist', (this.youtubeLink !== '' ? '1' : '0'));
            if (this.formType === FORM_TYPE.TRAINING) {
                if (this.selectedReferIdx === -2) {
                    formData.append('refer_idx', 0)
                } else {
                    formData.append('refer_idx', this.selectedReferIdx)
                }
            }
            for (let i = 0; i < this.imgSrcArr.length; i++) {
                if (this.imgSrcArr[i]) {
                    const curImgSrc = this.imgSrcArr[i];
                    if (curImgSrc.isFileTag && this.$refs[curImgSrc.id].value !== '') {
                        formData.append('file' + i, this.$refs[curImgSrc.id].files[0]);
                    }
                }
            }

            const res = await this.$Axios.post('/api/soccerhow/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) {
                this.closeAction()
                this.refresh(true, res.data.first_parent_idx)
                if (this.isFromPageBottom && this.formType !== FORM_TYPE.TRAINING) {
                    this.completeAction(res.data.first_parent_idx)
                    this.beforeCompleteAction(true, res.data.first_parent_idx)
                }
                if (this.formType === FORM_TYPE.TRAINING) {
                    setTimeout(() => {
                        this.completeAction(res.data.first_parent_idx)
                        this.beforeCompleteAction(true, res.data.first_parent_idx)
                        // this.$GlobalStore.addModal('CompleteMissonPopup', { isModalBackTransparent: true, transitionName: '', mission_type: MISSION_TYPE.UPLOAD_TRAINING_VIDEO })
                    }, 500)
                }
            }
        },
        deleteImg(i) {
            this.$set(this.imgSrcArr, i, null)
            this.$refs['file' + i].value = ''
        },
        detectLink() {
            const isYoutubeLinkComplete = this.$Util.checkYoutubeLink(this.youtubeLink);
            if (isYoutubeLinkComplete) {
                this.isShowYoutubeFrame = true;
            }
        },
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, isVideo: false, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.isVideo = true
                        // this.imgSrcArr = [...this.imgSrcArr, data];
                        this.$set(this.imgSrcArr, this.curIndex, data)
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt 만 업로드 가능합니다.');
                }
            }
        },
        inactiveAttachments() {
            this.imgSrcArr = [];
            this.$refs.file0.value = '';
            this.$refs.file1.value = '';
            this.$refs.file2.value = '';
            this.youtubeLink = '';
            this.isShowYoutubeFrame = false;
        },
        showFiles(index) {
            this.curIndex = index
            // if (this.imgSrcArr.length >= 3) {
            //     alert('최대 3개까지 업로드 가능합니다.');
            //     return;
            // }

            // if (this.youtubeLink !== '') {
            //     const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">기존에 업로드한 미디어가 삭제됩니다.<br>다른 미디어로 변경할까요?</div>`;
            //     this.$GlobalStore.showConfirm(html, async () => {
            //         this.inactiveAttachments();

            //         for (let i = 0; i < 3; i++) {
            //             if (this.$refs['file' + i].value === '') {
            //                 this.$refs['file' + i].click();
            //                 return;
            //             }
            //         }
            //     }, '변경하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
            //     return;
            // }
            for (let i = 0; i < 3; i++) {
                if (this.$refs['file' + i].value === '') {
                    this.$refs['file' + i].click();
                    return;
                }
            }
        },
    },
    created() {
        this.makeFeedAsk = this.$Once(this.makeFeedAsk)
        this.makeFeed = this.$Once(this.makeFeed)
        this.device = this.$cookies.get('device')
    }
}
</script>

<style scoped>
.ellipsis {
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

textarea::placeholder {
    font-weight: 500;
    color: #BBBBBB;
    font-size: 18px;
    line-height: 24px;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}

.training_banner_item {
    background: #FFFFFF80;
    border-radius: 12px;
    padding: 14px 12px;
    box-shadow: 0px 1px 4px 0px #0000001A;
    border: 2px solid transparent;
}

.training_banner_item:last-child:nth-child(odd) {
    grid-column: span 2;
}

.active {
    border: 2px solid var(--color-main);
    background-color: var(--color-main);
    color: #fff;
}
</style>